import { IInstrumentPartition, ITestPlanDirection, InstrumentPartition } from "./InstrumentPartition";
import { TestplanInstrumentOperations } from "./TestplanInstrumentOperations";

export interface ITestPlanInstrument {
  id: string;
  name: string;
  partitionsCount: number;
  partitions: IInstrumentPartition[];
  positionWidth: number;
  isFixedPosition: boolean;
  fixedPositionWidth: number;
  stripLength: number;
  defaultCount: number;  
  directions: ITestPlanDirection[];
  isAutoline: boolean;
}

export interface IInstrumentsData {
  instrument: ITestPlanInstrument;
  stripLength: number;
  partitionsCount: number;
  isFixed: boolean;
  partitions: IInstrumentPartition[];  
}

export class InstrumentData implements ITestPlanInstrument {
  id: string;
  name: string;
  partitionsCount: number;
  partitions: IInstrumentPartition[];
  positionWidth: number;
  isFixedPosition: boolean;
  stripLength: number;
  fixedPositionWidth: number;  
  isAutoline: boolean;
  readonly defaultCount: number;
  readonly directions: ITestPlanDirection[];

  constructor(id: string, name: string, directions: ITestPlanDirection[], isAutoline: boolean) {
    this.id = id;
    this.name = name;
    this.partitions = [];
    this.isAutoline = isAutoline;

    this.defaultCount = 1;

    this.isFixedPosition = false;
    this.fixedPositionWidth = 0;
    this.stripLength = 10000;
    this.partitionsCount = this.defaultCount;

    this.directions = directions;

    TestplanInstrumentOperations.setPositionWidth(this, 0);
    TestplanInstrumentOperations.setPartitions(this, this.partitionsCount);
  }    
}